import { useTaskTypesCache } from 'hooks/caches/static/use-task-types';
import { useTaskStatusesCache } from 'hooks/caches/static/use-task-statuses';
import { useTaskPrioritiesCache } from 'hooks/caches/static/use-task-priorities';
import { useTaskClosedReasonsCache } from 'hooks/caches/static/use-task-closed-reasons';
import { useTaskArchiveTimingsCache } from 'hooks/caches/static/use-task-archive-timings';
import { useRegionsCache } from 'hooks/caches/static/use-regions';
import { useDepartmentsCache } from 'hooks/caches/static/use-departments';
import { useStaffMembersCache } from 'hooks/caches/static/use-staffMembers';
import { useConversationTypesCache } from 'hooks/caches/static/use-conversation-types';
import { useTeamsCache } from 'hooks/caches/static/use-teams';
import { useMemo } from 'react';

export const useStaticCache = () => {
  const regionsCache = useRegionsCache();
  const departmentsCache = useDepartmentsCache();
  const staffMembersCache = useStaffMembersCache();
  const taskTypesCache = useTaskTypesCache();
  const taskStatusesCache = useTaskStatusesCache();
  const taskPrioritiesCache = useTaskPrioritiesCache();
  const closedReasonsCache = useTaskClosedReasonsCache();
  const taskArchiveTimingsCache = useTaskArchiveTimingsCache();
  const conversationTypesCache = useConversationTypesCache();
  const teamsCache = useTeamsCache();

  const isStaticCacheLoading = useMemo(
    () =>
      taskTypesCache.isTaskTypesLoading &&
      taskStatusesCache.isTaskStatusesLoading &&
      taskPrioritiesCache.isTaskPrioritiesLoading &&
      closedReasonsCache.isClosedReasonsLoading &&
      taskArchiveTimingsCache.isArchiveTimingsLoading &&
      regionsCache.isRegionsLoading &&
      departmentsCache.isDepartmentsLoading &&
      staffMembersCache.isStaffMembersLoading &&
      conversationTypesCache.isConversationTypesLoading &&
      teamsCache.isTeamsLoading,
    [
      taskTypesCache.isTaskTypesLoading,
      taskStatusesCache.isTaskStatusesLoading,
      taskPrioritiesCache.isTaskPrioritiesLoading,
      closedReasonsCache.isClosedReasonsLoading,
      taskArchiveTimingsCache.isArchiveTimingsLoading,
      regionsCache.isRegionsLoading,
      departmentsCache.isDepartmentsLoading,
      staffMembersCache.isStaffMembersLoading,
      conversationTypesCache.isConversationTypesLoading,
      teamsCache.isTeamsLoading
    ]
  );

  return {
    isCacheLoading: isStaticCacheLoading,
    teamsCache
  };
};
